module.exports = __webpack_public_path__ + "static/media/cq_pagamenti.c0d3f22b.svg";